/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../state/hooks';
import { ThemeState } from './theme.interfaces';

const initialState: ThemeState = {
  theme: localStorage.getItem('theme') || 'light',
};

export const themeSlice = createSlice({
  name: 'themeSlice',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<string>) => {
      state.theme = action.payload;
      localStorage.setItem('theme', action.payload);
    },
  },
});

export const useThemeSelector = (state: RootState): string => {
  return state.themeReducer.theme;
};

export const ThemeSelectors = {
  useThemeSelector,
};

export const { setTheme } = themeSlice.actions;
